import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2cfdbf77"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-info" }
const _hoisted_2 = { class: "cart-contents contents" }
const _hoisted_3 = { class: "heaer-address" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/" }, "首页", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1))
const _hoisted_6 = { class: "msg" }
const _hoisted_7 = { class: "order-msg" }
const _hoisted_8 = { class: "show" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "show-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-wancheng" })
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = {
  key: 0,
  class: "show-msg"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = {
  key: 0,
  class: "order-msg-info"
}
const _hoisted_14 = { class: "address" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = { class: "order-user" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = { class: "order-pay" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-a-Group14379" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = { class: "order-more" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hat-goods" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-jiarehuoyan" }),
  /*#__PURE__*/_createTextVNode(" 热销方案 ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_home_head = _resolveComponent("home-head")!
  const _component_current_address = _resolveComponent("current-address")!
  const _component_GoodsList = _resolveComponent("GoodsList")!
  const _component_html_footer = _resolveComponent("html-footer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_home_head),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_current_address, null, {
          address: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" > 支付详情 ")
          ]),
          _: 1
        }),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _hoisted_10,
            (_ctx.orderData.datas.status==2)
              ? (_openBlock(), _createElementBlock("p", _hoisted_11, "支付成功!"))
              : _createCommentVNode("", true)
          ]),
          _hoisted_12,
          (_ctx.orderData.datas.address)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("p", _hoisted_14, [
                  _createTextVNode(" 收货地址："),
                  _createElementVNode("span", null, _toDisplayString(_ctx.orderData.datas.address.province) + _toDisplayString(_ctx.orderData.datas.address.city) + _toDisplayString(_ctx.orderData.datas.address.area) + _toDisplayString(_ctx.orderData.datas.address.address), 1)
                ]),
                _hoisted_15,
                _createElementVNode("p", _hoisted_16, [
                  _createTextVNode("收货人："),
                  _createElementVNode("span", null, _toDisplayString(_ctx.orderData.datas.address.contacts) + " " + _toDisplayString(_ctx.orderData.datas.address.phonenumber), 1)
                ]),
                _hoisted_17,
                _createElementVNode("p", _hoisted_18, [
                  _createTextVNode(" 实付款： "),
                  _createElementVNode("span", null, [
                    _hoisted_19,
                    _createTextVNode(_toDisplayString(_ctx.orderData.datas.price), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_20,
          _createElementVNode("div", _hoisted_21, [
            _createTextVNode(" 您可以："),
            _createElementVNode("span", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.gotoDown && _ctx.gotoDown(...args)))
            }, "下载设计方案"),
            _createTextVNode(),
            _createElementVNode("span", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.gotoDetai && _ctx.gotoDetai(...args)))
            }, "查看交易详情"),
            _createElementVNode("span", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.gotoHome && _ctx.gotoHome(...args)))
            }, "返回首页")
          ])
        ])
      ]),
      _hoisted_22
    ]),
    _withDirectives(_createVNode(_component_GoodsList, {
      goodslit: _ctx.goodslit.datas.data.slice(0,5)
    }, null, 8, ["goodslit"]), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode(_component_html_footer)
  ]))
}